export default __webpack_public_path__ + "static/images/home-taxi-exo.png";